import { Box, Theme, styled } from '@mui/material'
import { NavLink } from 'react-router-dom'

export const StyledSidebarCloseBtn = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 20,
  right: -14,
  display: 'flex',
  zIndex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  width: '28px',
  height: '28px',
  borderRadius: '50%',
  border: `2px solid ${theme.palette.white.main}`,
  backgroundColor: theme.palette.background.dark
}))

export const StyledSidebar = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  position: 'fixed',
  top: '68px',
  left: 0,
  bottom: 0,
  width: '250px',
  zIndex: 100,
  overflowY: 'auto'
}))

interface ISidebar {
  theme: Theme
  isSideNavOpen: boolean
}

export const sidebarBoxStyles = ({ theme, isSideNavOpen }: ISidebar) => {
  return {
    backgroundColor: theme.palette.background.dark,
    // backgroundColor: '#0d324a',
    // backgroundColor: '#102d42',
    // backgroundColor: '#173f4e',
    // backgroundColor: '#1a4457',
    // backgroundColor: '#223f50',
    // backgroundColor: '#102a3a',
    // backgroundColor: '#15312c',
    top: '70px',
    left: 0,
    bottom: 0,
    width: isSideNavOpen ? '0' : '110px',
    zIndex: 100,
    transition: theme.transitions.create(['width'], {
      duration: theme.transitions.duration.short
    }),
    borderTopRightRadius: theme.spacing(2),
    overflow: 'visible',
    ['&::-webkit-scrollbar']: {
      display: 'none'
    },
    [theme.breakpoints.down('xl')]: {
      width: isSideNavOpen ? '0' : '140px'
    },
    [theme.breakpoints.down('lg')]: {
      width: isSideNavOpen ? '0' : '140px',
      position: 'absolute',
      top: `max(70px, calc(58px + ${theme.customVariables.safeAreaInsetTop}))`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      zIndex: 999,
      borderTopRightRadius: theme.spacing(0)
    },
    [theme.breakpoints.down('sm')]: {
      top: `max(70px, calc(50px + ${theme.customVariables.safeAreaInsetTop}))`
    }
  }
}

export const StyledSidebarNavLink = styled(NavLink)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexDirection: 'column',
  position: 'relative',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  textDecoration: 'none',
  color: theme.palette.white.main,
  width: '100%',
  borderLeft: `3px solid transparent`,
  borderRight: `3px solid transparent`,
  transition: theme.transitions.create(['all'], {
    duration: theme.transitions.duration.short
  }),
  marginBottom: theme.spacing(1),
  '&.active, &:hover': {
    color: theme.palette.info.light
  },
  '&.active': {
    borderLeftColor: theme.palette.info.light
  }
}))

export const MobileLogoutWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  color: theme.palette.white.main,
  padding: theme.spacing(
    1,
    2,
    `calc(${theme.customVariables.safeAreaInsetBottom} + ${theme.spacing(2)})`,
    2
  ),
  width: '100%',
  borderLeft: `3px solid transparent`,
  transition: theme.transitions.create(['all'], {
    duration: theme.transitions.duration.short
  }),
  cursor: 'pointer'
}))

export const styledSidebarNavIcon = (theme: Theme, isSideNavOpen: boolean) => ({
  opacity: isSideNavOpen ? 0 : 1,
  transition: theme.transitions.create(['opacity'], {
    duration: 500,
    easing: 'ease-in-out'
  }),
  lineHeight: 1.1,
  textAlign: 'center'
})

export const styledNavIconBox = (theme: Theme, isSideNavOpen: boolean) => ({
  display: 'flex',
  marginBottom: theme.spacing(0.5),
  width: isSideNavOpen ? 0 : '100%',
  alignItems: 'center',
  justifyContent: 'center',
  transition: theme.transitions.create(['width'], {
    duration: theme.transitions.duration.short,
    easing: 'ease-in-out'
  })
})

export const styledNavList = (theme: Theme, isSideNavOpen: boolean) => ({
  paddingBottom: theme.spacing(9),
  visibility: isSideNavOpen ? 'hidden' : 'visible',
  opacity: isSideNavOpen ? 0 : 1,
  transition: theme.transitions.create(['width'], {
    duration: theme.transitions.duration.short,
    easing: 'ease-in-out'
  })
})
